import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';
import { Breakpoints } from '../../../../styled/constants';

export const SizesSectionContainer = styled(FlexibleDiv)<{
  $withSpaceBetween: boolean;
}>`
  width: 100%;
  gap: 30px;
  margin-bottom: 15px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 10px;
    ${({ $withSpaceBetween }) =>
      $withSpaceBetween
        ? css`
            justify-content: space-between;
          `
        : css`
            gap: 20px;
          `}
  }
`;

export const SizesTitle = styled(Typography)`
  margin: 0;
  white-space: nowrap;
  width: max-content;
  flex: 1;
`;

export const InfoWrapper = styled.div`
  width: max-content;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    flex: 1;
  }
`;

export const SizeDescription = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: lowercase;
`;
